"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingIssuesAlert = exports.Container = void 0;
const React = __importStar(require("react"));
const hui_1 = require("@travelnest/hui");
const theme_1 = __importDefault(require("../styles/theme"));
const MaxWidthWrapper_1 = require("../max-width/MaxWidthWrapper");
const api_1 = __importDefault(require("../../../api"));
const styled_1 = __importDefault(require("@emotion/styled"));
const useExperiment_1 = require("../../../hooks/useExperiment");
const __1 = require("../../..");
exports.Container = styled_1.default.div `
	padding: 0
		${(props) => props.sideMargin !== undefined
    ? `${props.sideMargin}px`
    : theme_1.default.layout.spacing.standard};

	@media only screen and (min-width: 768px) {
		padding: 0
			${(props) => props.sideMargin !== undefined
    ? `${props.sideMargin}px`
    : theme_1.default.layout.spacing.xLarge};
	}
    p {
        max-width: none;
    }
`;
const ListingIssuesAlert = ({ propertyId }) => {
    const { customerId } = React.useContext(__1.AppContext);
    const experiments = (0, useExperiment_1.useCustomerExperiments)(customerId);
    const shouldShowListingIssuesAlert = (experiments === null || experiments === void 0 ? void 0 : experiments.new_listings_experience) === 'on';
    const [hasAnyIssuesState, setHasAnyIssuesState] = React.useState(false);
    React.useEffect(() => {
        if (propertyId && shouldShowListingIssuesAlert) {
            api_1.default.listingIssues.getListingsByProperty(propertyId).then((data) => {
                const hasAnyIssues = data.some((listing) => (listing === null || listing === void 0 ? void 0 : listing.listingIssues) && listing.listingIssues.length > 0);
                setHasAnyIssuesState(hasAnyIssues);
            });
        }
    }, [propertyId, shouldShowListingIssuesAlert]);
    const redirectToNewListingsExperience = () => {
        window.location.assign(`${window.location.origin}/admin/property/${propertyId}/listings`);
    };
    return shouldShowListingIssuesAlert && hasAnyIssuesState ? (React.createElement(React.Fragment, null,
        React.createElement(MaxWidthWrapper_1.MaxWidthWrapper, null,
            React.createElement(exports.Container, null,
                React.createElement(hui_1.InlineAlert, { heading: "Action required: Additional information needed", content: "One or more channels have requested additional information before your property can go live.", variant: "negative", actionButton: { text: 'View details', onClick: redirectToNewListingsExperience } }))))) : null;
};
exports.ListingIssuesAlert = ListingIssuesAlert;
//# sourceMappingURL=ListingIssuesAlert.js.map